module.exports = __webpack_public_path__ + "img/男-膀胱癌h.8084de45.png";